import type {
    WebMcpListResponse,
    WebMcpDetailItem,
    WebMcpEnableData,
    WebMcpListParams,
    WebMcpDetailParams,
} from '../types';

export const McpApiService = Symbol('McpApiService');

export interface McpApiService {
    getList(params?: WebMcpListParams): Promise<WebMcpListResponse>;
    getDetail(id: string, params?: WebMcpDetailParams): Promise<WebMcpDetailItem>;
    enable(id: string): Promise<WebMcpEnableData>;
    disable(id: string): Promise<WebMcpEnableData>;
}
